'use strict';

wbApp.directive('wbSemesterMultiSelect', ['$timeout', '$translate', 'semesterSvc',
    function ($timeout, $translate, semesterSvc) {
        function formatResult(model) {
            return model.name;
        }

        function formatSelection(model) {
            return model.name;
        }

        return {
            restrict: 'A',
            require: '?ngModel',
            priority: 1,
            scope: true,
            link: function (scope, elm, attrs, ctrl) {

                var models = semesterSvc.getAllAsync();

                models.$promise.then(function () {
                    $timeout(function () {
                        $(elm).select2({
                            formatResult: formatResult,
                            formatSelection: formatSelection,
                            dropdownAutoWidth: true,
                            allowClear: false,
                            minimumResultsForSearch: -1,
                            id: function (model) { return model.id; },
                            data: models,
                            multiple: true
                        });

                        ctrl.$render();
                    });
                });


                ctrl.$parsers.unshift(function (viewValue) {
                    if (!viewValue) {
                        return [];
                    } else {
                        if (Array.isArray(viewValue)) {
                            return _.map(viewValue, function (n) { return parseInt(n); });
                        } else {
                            return _.map(viewValue.split(','), function (n) { return parseInt(n); });
                        }
                    }
                });

                ctrl.$formatters.unshift(function (value) {
                    if (!value) {
                        return "";
                    } else {
                        if (Array.isArray(value)) {
                            return _.map(value, function (n) { return n + ''; }).join();
                        } else {
                            return _.map(value.split(','), function (n) { return n + ''; }).join();
                        }
                    }
                });

                elm.bind("$destroy", function () {
                    elm.select2("destroy");
                });

                attrs.$observe('readonly', function (value) {
                    elm.select2('readonly', !!value);
                });
            }
        }
    }]);